import React, {useEffect, useState} from 'react';


import WorkTabs from "./WorkTabs";
import WorkDashboardFrame from "../WorkDashboard/WorkDashboardLayout";
import WorkQueueFrame from "../WorkQueue/Panels/WorkQueueFrame";
import WorkIssuanceObligationFinancialGrid from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationFinancialGrid";
import WorkIssuanceObligationUsageGrid from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationUsageGrid";
import WorkIssuanceObligationLicenseGrid from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationLicenseGrid";
import WorkIssuanceObligationPlatformGrid from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationPlatformGrid";
import WorkIssuanceFrame from "../WorkIssuance/WorkIssuanceFrame";
import WorkIssuanceObligationViewershipGrid
    from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationViewershipGrid";
import WorkIssuanceObligationProductGrid
    from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationProductGrid";
import WorkIssuanceObligationSubscriberGrid
    from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationSubscriberGrid";
import WorkIssuanceObligationStakeholderListGrid
    from "../WorkIssuance/WorkIssuanceObligation/DetailDrawers/WorkIssuanceObligationStakeholderListGrid";
import WorkWelcomeLayout from "../WorkWelcome/WorkWelcomeLayout";
import {useDispatch, useSelector} from "react-redux";
import ContractFrame from "../Contract/ContractFrame";
import {changeContract} from "../Contract/contractSlice";
import {changeWork} from "./workSlice";
import {changeWorkQueue} from "../WorkQueue/workQueueSlice";




export default function WorkFrame(props) {


    const searchScreenVisible = useSelector((state) => state.workSlc.value.searchScreenVisible);
    const workDashboardVisible = useSelector((state) => state.workSlc.value.workDashboardVisible);
    const workContractVisible = useSelector((state) => state.workSlc.value.workContractVisible);
    const workIssuanceVisible = useSelector((state) => state.workSlc.value.workIssuanceVisible);

    const dispatchData = useDispatch();


    // useEffect(() => {
    //     // Define the message event listener
    //     const handleMessage = (event) => {
    //         // Ensure the message is from a trusted origin
    //         // if (event.origin !== 'http://localhost:3000') return; // Replace with your main app's origin
    //         // dispatchData(changeContract({contractDrilldownVisible: true,contractGridVisible: true}));
    //         // Add the event listener for messages
    //         console.log("I just got a message top part");
    //         window.addEventListener('message', handleMessage);
    //
    //         // Dispatch the received data to the Redux store
    //         if (event.data && event.data.type === 'UPDATE_DATA') {
    //             // dispatch(updateData(event.data.payload));
    //             dispatchData(changeWork({workTabsIndex: 2,
    //                 searchScreenVisible: false,
    //                 workDashboardVisible: false,
    //                 workContractVisible: true,
    //                 workIssuanceVisible: false}));
    //             dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null,propertyDropdownListState:true,
    //                 workQueueFinalize: false, propertyDropdownTitleId: null}));
    //             console.log("I just got a message bottom part");
    //         }
    //     };


    //
    //     // Clean up the event listener on component unmount
    //     return () => {
    //         window.removeEventListener('message', handleMessage);
    //     };
    // }, []);

    useEffect(() => {
        const handleMessage = (event) => {
            console.log("Message received:", event.origin, event.data);

            // If you want origin validation, do it here:
            // const allowedOrigins = ["http://localhost:3000", "https://yourdomain.com"];
            // if (!allowedOrigins.includes(event.origin)) return;

            if (event.data?.type === "UPDATE_DATA") {
                dispatchData(
                    changeWork({
                        workTabsIndex: 2,
                        searchScreenVisible: false,
                        workDashboardVisible: false,
                        workContractVisible: true,
                        workIssuanceVisible: false,
                    })
                );

                dispatchData(
                    changeWorkQueue({
                        selectedContractId: event.data.payload.contractId,
                        newSetupContractId: event.data.payload.contractId,
                        selectedContractName: null,
                        propertyDropdownListState: true,
                        workQueueFinalize: false,
                        propertyDropdownTitleId: null,
                        fetchTopLevel: true
                    })
                );

                console.log("UPDATE_DATA handled");
                console.log("data received:");
                console.log(event.data);
                console.log("payload received:");
                console.log(event.data.payload);
                console.log("contract id received:");
                console.log(event.data.payload.contractId);
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [dispatchData]);





    return (
        <div>

            <WorkTabs/>
            {searchScreenVisible && <WorkWelcomeLayout/>}
            {/*<SearchScreen/>*/}
            {/*{workDashboardVisible && <WorkDashboardFrame/>}*/}
            {workDashboardVisible && <ContractFrame/>}
            {workContractVisible && <WorkQueueFrame/>}
            {workIssuanceVisible && <WorkIssuanceFrame/>}
            {/*{workIssuanceVisible && <WorkIssuanceObligationGrid/>}*/}
            {/*{useSelector((state) => state.obligationHierarchyControlsSlc.value.financialGridOpen) && <WorkIssuanceObligationFinancialGrid/>}*/}
            <WorkIssuanceObligationUsageGrid/>
            <WorkIssuanceObligationLicenseGrid/>
            <WorkIssuanceObligationPlatformGrid/>
            <WorkIssuanceObligationViewershipGrid/>
            <WorkIssuanceObligationProductGrid/>
            <WorkIssuanceObligationSubscriberGrid/>
            <WorkIssuanceObligationStakeholderListGrid/>
            <WorkIssuanceObligationFinancialGrid/>
            {/*<BulkEditGrid/>*/}
        </div>

    )


}

